export interface ICohortUpdate {
  title: string;
  description?: string;
}

export interface ICohortIndividualCreate {
  registry_individual_id: string;
  registry_id: string;
}

export interface ICohortIndividualSelected {
  cohort_individual_id: string;
  registry_name: string;
  individual_name: string;
}

export interface ICohortCreate extends ICohortUpdate {
  user_id: string;
}

export interface ICohortWorkingForm extends Partial<ICohortUpdate> {}

export interface ICohort extends ICohortCreate {
  id: string;
  description: string;
  time_created: string;
  time_updated: string;
}

export const initialCohortWorkingForm: ICohortWorkingForm = {
  title: "",
  description: "",
};
